import { Text } from "@mantine/core";
import { useSelector } from "src/redux/hooks";

const EntryText = () => {
  const {
    lbentry: { entryText },
  } = useSelector(state => state.generatorSlice);
  return (
    <Text c="gray" fz={14}>
      {entryText ?? ""}
    </Text>
  );
};
export default EntryText;
